export default __webpack_public_path__ + "static/media/logo-header.504c7d97.png";